import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IffhsService } from 'src/app/data-services/iffhs.service';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { UserService } from 'src/app/data-services/user.service';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import countries from '../../../../../../../assets/json/countries.json';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-edit-award-winner',
  templateUrl: './edit-award-winner.component.html',
  styleUrls: ['./edit-award-winner.component.css']
})
export class EditAwardWinnerComponent implements OnInit {

  editAwardWinnerForm: FormGroup;
  id: number;
  countryData: any = {};
  searchText: any;
  currentUser: any;
  submitted = false;
  isLoaderVisible = false;
  isSubmitted = true;
  errorMessage: string = '';
  visible = true;
  onChangeValue = '';
  winner: any = {};
  maxDate: Date;
  minDate: Date;
  years = [];
  awards = [];
  banners = [];
  countryList: { name: string, id: string }[] = countries;
  constructor(
    private route: ActivatedRoute,
    private iffhsService: IffhsService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastrService: ToastrService,
    public datePipe: DatePipe,
  ) {
    this.route.queryParams.subscribe(params => this.id = params.id);
    this.minDate = new Date();
    this.maxDate = new Date();
    this.minDate.setDate(this.minDate.getDate() - 52850);
    this.maxDate.setDate(this.maxDate.getDate() - 2920);
    this.years = Array(50).fill(0).map((x, i) => ({ name: (i + 1990) }));

  }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.getWinnerById();
    this.getAllBanners();
  }

  getWinnerById() {
    this.isLoaderVisible = true;
    const data = {
      winnerId: 1
    };
    this.iffhsService.getWinnerById(data).subscribe((res: any) => {
      this.winner = res;
      this.isLoaderVisible = false;
    },
      (error) => {
        console.log(error);
      },
      () => {
        this.initForm();
      }
    );
  }
  initForm() {
    this.editAwardWinnerForm = this.formBuilder.group({
      bannerId: [this.winner.id, Validators.required],
      winnerId: [this.id],
      award: [this.winner.award_id, Validators.required],
      firstName: [this.winner.name, Validators.required],
      lastName: [this.winner.lastName],
      winnerCountry: [this.winner.country_id, Validators.required],
      dob: [this.winner.dob, Validators.required],
      yearOfAward: [this.winner.year, Validators.required],
      winnerAvatar: [''],
      createdBy: [this.currentUser.success.user.id],
    });
  }
  onChange(e) {
    this.onChangeValue = e.target.value || 0;
    console.log(this.onChangeValue);
  }
  getBannerAwards() {
    this.isLoaderVisible = true;
    const data = {
      bannerId: this.onChangeValue,
    };
    this.iffhsService.getBannerAwards(data).subscribe((res: any) => {
      this.banners = res.banners;
      this.isLoaderVisible = false;
    });
  }
  onChangeBanner(e) {
    this.onChangeValue = e.target.value || 0;
    console.log(this.onChangeValue);
    this.getAwardsByBanner();
    this.editAwardWinnerForm.get('bannerId').setValue(this.onChangeValue);
  }
  getAwardsByBanner() {
    this.isLoaderVisible = true;
    const data = {
      bannerId: this.onChangeValue,
    };
    this.iffhsService.getBannerAwards(data).subscribe((res: any) => {
      this.awards = res.awards;
      this.isLoaderVisible = false;
    });
  }
  getAllBanners() {
    this.isLoaderVisible = true;
    this.iffhsService.getAllBanners().subscribe((res: any) => {
      this.banners = res.banners;
      this.isLoaderVisible = false;
    });
  }

  onFileSelect(event) {
    const winnerAvatar = event.target.files[0];
    const type = event.target.files[0].type;
    if (type.match(/image\/*/) === null) {
      this.toastrService.error('Only images are supported', 'Message!');
      return;
    }
    this.editAwardWinnerForm.get('winnerAvatar').setValue(winnerAvatar);

  }
  goToDashboard() {
    this.router.navigate(['/add-award-winner']);

  }

  get f() { return this.editAwardWinnerForm.controls; }
  editWinner() {
    this.submitted = true;
    this.isLoaderVisible = true;
    if (this.editAwardWinnerForm.invalid) {
      return;
    }
    const dob = this.datePipe.transform(this.f.dob.value, 'yyyy-MM-dd');
    const fd = new FormData();
    fd.append('winnerId', this.editAwardWinnerForm.get('winnerId').value);
    fd.append('bannerId', this.editAwardWinnerForm.get('bannerId').value);
    fd.append('award', this.editAwardWinnerForm.get('award').value);
    fd.append('firstName', this.editAwardWinnerForm.get('firstName').value);
    fd.append('lastName', this.editAwardWinnerForm.get('lastName').value);
    fd.append('winnerCountry', this.editAwardWinnerForm.get('winnerCountry').value);
    fd.append('dob', dob);
    fd.append('yearOfAward', this.editAwardWinnerForm.get('yearOfAward').value);
    fd.append('winnerAvatar', this.editAwardWinnerForm.get('winnerAvatar').value);
    fd.append('createdBy', this.editAwardWinnerForm.get('createdBy').value);

    this.iffhsService.editWinner(fd).pipe(first()).subscribe(
      data => {
        this.isLoaderVisible = false;
        this.toastrService.success('Award Winner Updated!', 'Message!');
        this.submitted = true;
      },
      error => {
        console.log(error);
        this.isLoaderVisible = false;
        this.toastrService.error('Something went wrong please Try Later!', 'Message!');

      }
    );
    this.resetForm();
  }
  resetForm() {
    this.getWinnerById();
    this.editAwardWinnerForm = this.formBuilder.group({
      bannerId: [this.winner.id, Validators.required],
      winnerId: [this.id],
      award: [this.winner.award_id, Validators.required],
      firstName: [this.winner.name, Validators.required],
      lastName: [this.winner.lastName],
      winnerCountry: [this.winner.country_id, Validators.required],
      dob: [this.winner.dob, Validators.required],
      yearOfAward: [this.winner.year, Validators.required],
      winnerAvatar: [''],
      createdBy: [this.currentUser.success.user.id],
    });
  }

}
